// Restructured LandingPage.js with purple background extending to hero

import React from 'react';
import './LandingPage.css';
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-wrapper">
      {/* Purple Background Section Through Hero */}
      <div className="purple-background">
        <header className="page-header">
          <div className="header-left">
            <img src="/audenemblembald-200w.png" alt="Auden Logo" className="header-logo" />
            <span className="header-title">Auden AI</span>
          </div>
          <div className="header-right">
            <button className="header-button" onClick={() => navigate("/login")}>Login</button>
      {/*      <button className="header-button" onClick={() => navigate("/register")}>Get Started</button> */}
          </div>
        </header>


        <section className="landing-page">
          <section className="hero grid-two-cols">
            <div className="hero-text">
              <h1 className="tagline">No more digging.</h1>
              <p className="subheadline">Auden - your projects' hippocampus.</p>
          
                <div className="demo-button-wrapper">
                  <a
                    className="demo-button"
                    href="https://www.loom.com/share/46c0473d8b3b4d80ae8ee420073b7bd5?sid=6fd8179b-94fb-4ae8-afe5-4fa42726593f"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Demo
                  </a>
                </div>
                <div className="waitlist-button-wrapper">
                  <a
                    className="waitlist-button"
                    href="https://forms.gle/nFC5LYShozwTqNM59"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Get on the Waitlist
                  </a>
                </div>
              </div>

            <div className="hero-image"><img src="/fredrick.gif" alt="Auden animation" className="hero-gif" /></div>
          </section>
        </section>
      </div>

      {/* Main Content From Value Prop Onward */}
      <div className="landing-page">
        <section className="value-prop">
          <h2>Deliver projects confidently</h2>
          <p className="supporting-text">
            An AI-powered project historian that captures essential knowledge as you work <br /> so you always have the context you need.
          </p>
          <hr className="divider" />
        </section>

        <div className="side-by-side-heading">
          <h1>There is no consistent source of truth on complex projects.</h1>
          <h2>The impact?</h2>
        </div>

        <section className="side-by-side">
          <div className="hero-image">
            <img src="/jimothyfreakout-1000w.png" alt="Auden diagram" className="diagram-image" />
          </div>

          <div className="block">
            <pre className="formatted-pre">
              <strong>🔥 Billable Hours are Wasted</strong><br />
                  When team members have to dig for context to make progress<br /><br />

              <strong>💸 Budgets get Cratered</strong><br />
                  As team members burn through billable hours<br /><br />

              <strong>😵‍💫 Burnout Builds Up</strong><br />
                  When team members constantly have to dig for information
            </pre>
          </div>
        </section>
        <hr className="divider" />
        
        <br /><br />

        <section className="solution">
          <h1>The solution? </h1>
          <h2>A Living Source of Truth for all your projects. </h2>
          <pre className="supporting-text formatted-pre">
            {"\u00a0".repeat(8)} Imagine if every project team member had a shared, always-on assistant. {"\n"}      
            {"\u00a0".repeat(8)} Auden acts as your project’s long term memory - capturing insights from{"\n"}{"\n"}
            {"\u00a0".repeat(8)}Group chats{"\n"}
            {"\u00a0".repeat(24)}Emails{"\n"}
            {"\u00a0".repeat(36)}Meetings{"\n"}
            {"\u00a0".repeat(52)}Files{"\n"}
            {"\u00a0".repeat(60)}across everyone working on the project.{"\n"}{"\n"}
            {"\u00a0".repeat()}Equipped with project insights, Auden can answer any project-related question later.
          </pre>
          <hr className="divider" />
        </section>

        <br /><br />

        <section className="audience">
          <h2>Who It's For</h2>
          <div className="persona-grid">
            <div className="persona">
              <h3>Designers</h3>
              <p> 
                “What did we decide and why?”<br /><br />
                → Instantly recall decisions and stay in sync without digging or playing telephone.
              </p>
            </div>
            <div className="persona">
              <h3>Project Managers</h3>
              <p>
                “Who approved this, and when did it change?”<br /><br />
                → Track project memory across teams, and onboard teammates without slowing down.
              </p>
            </div>
            <div className="persona">
              <h3>Principals & Execs</h3>
              <p>
                “Why do we keep making the same mistakes?”<br /><br />
                → Preserve tribal knowledge, cut delays, and make decisions grounded in historical truths.
              </p>
            </div>
          </div>
        </section><br /><br />
        <h2>About Me</h2>
        <section className="about">
          <p>
            I'm Jason, an electrical design engineer that's helped design datacenters for FAANG companies and developers.<br /><br />
            I've seen firsthand how crucial information gets lost during project delivery, and wasted too much time tracking down info that should be easy to find.
            <br /><br />Auden is my answer to deep-rooted inefficiencies in project workflows - built by someone who's lived in the chaos. And was reborn from it.
          </p>
        </section><br /><br />

        <section className="conversion">
          <h2>Get in Touch!</h2>
          <div className="cta-buttons">
              <a
                className="demo-button"
                href="https://www.loom.com/share/46c0473d8b3b4d80ae8ee420073b7bd5?sid=6fd8179b-94fb-4ae8-afe5-4fa42726593f"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Demo
              </a>
              <a
                className="waitlist-button"
                href="https://forms.gle/nFC5LYShozwTqNM59"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get on the Waitlist
              </a>
              <a href="mailto:jason@audensystems.ai" className="cta-link-button">
                Email Us
              </a>
          </div>
        </section>

        <footer className="footer">
          <img src="/audenemblembald-200w.png" alt="Auden Logo" className="header-logo" />
          <p>Auden AI Systems</p>
          <p>Contact: jason@audensystems.ai | www.linkedin.com/in/jasonigchoi</p>
          <p>San Francisco, CA</p>
          <p>© 2025 Auden AI Systems. All rights reserved.</p>
          <p className="footer-links"></p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;